import { MixpanelEventProperties } from './mixpanel.types';

export const MIXPANEL_PROPERTIES_MAP: Record<keyof MixpanelEventProperties, string> = {
    funnel: 'Funnel',
    reason: 'Trigger',
    emailDomain: 'Email Domain',
    codeActivationAttemptsCount: 'Activation total attempts',
};
